const ROLE_LABELS = {
  1: 'Super Admin',
  2: 'Admin',
  3: 'General User',
};

export function appRoleById(roleId) {
  const label = ROLE_LABELS[Number(roleId)];
  return label ? { id: Number(roleId), label } : null;
}

export function canViewOrganizationSettings(roleId) {
  const id = Number(roleId);
  return id === 1 || id === 2;
}

export function canViewUsers(roleId) {
  const id = Number(roleId);
  return id === 1 || id === 2;
}

export function isSuperAdminRole(roleId) {
  return Number(roleId) === 1;
}
